<div class="form" xmlns="http://www.w3.org/1999/html">
  <form
    class="header d-flex flex-column"
    [formGroup]="loginForm"
    (ngSubmit)="onSubmit()"
  >
    <h1 class="welcome-txt">Willkommen!</h1>
    <h2 class="welcome-txt">Melden Sie sich an, um fortzufahren</h2>
    <hr />
    <mat-form-field appearance="outline" class="w-100 mt-3">
      <mat-label>Benutzername</mat-label>
      <div class="d-flex">
        <input
          type="text"
          matInput
          placeholder="Benutzername"
          formControlName="username"
          required
        />
      </div>
    </mat-form-field>
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Passwort</mat-label>
      <div class="d-flex">
        <input
          [type]="hide() ? 'password' : 'text'"
          matInput
          placeholder="Passwort"
          formControlName="password"
          required
        />
        <i
          [class]="hide() ? 'bi bi-eye-slash' : 'bi bi-eye'"
          (click)="hide.set(!hide())"
        ></i>
      </div>
    </mat-form-field>

    <br />
    <br />

    <p *ngIf="storageService.error()" class="text-danger p-1">
      {{ storageService.error() }}
    </p>
    <button class="btn-group" type="submit">Anmelden</button>
    <p class="end-txt mt-4">
      Sollten Sie ihr Passwort vergessen haben, kann es durch den Administrator
      zurückgesetzt werden.
    </p>
  </form>
</div>
